import React from "react";
import { AuthCard } from "../components/authentication/AuthCard";
import { LoginForm } from "../components/authentication/LoginForm";
const Page = () => {
  return (
    <AuthCard>
      <LoginForm />
    </AuthCard>
  );
};

export default Page;
